import { render, staticRenderFns } from "./ModalCover.vue?vue&type=template&id=4dfeca76"
import script from "./ModalCover.vue?vue&type=script&lang=js"
export * from "./ModalCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports